import ApiService from "@/core/services/api.service";

// action types
export const FETCH_PROGRAMS = "fetchPrograms";
export const FETCH_PROGRAM = "fetchProgram";
export const STORE_PROGRAM = "storeProgram";
export const UPDATE_PROGRAM = "updateProgram";
export const DESTROY_PROGRAM = "destroyProgram";
export const UPLOAD_PROGRAM_FILE = "uploadProgramFile";
export const GET_PROGRAM_FILE_URL = "getProgramFileUrl";
export const START_PROGRAM = "startProgram";
export const STOP_PROGRAM = "stopProgram";

export const FETCH_PROGRAM_DESTINATIONS = "fetchProgramDestinations";
export const STORE_PROGRAM_DESTINATION = "storeProgramDestination";
export const DESTROY_PROGRAM_DESTINATION = "destroyProgramDestination";

// mutation types
export const SET_PROGRAMS = "setPrograms";
export const SET_PROGRAMS_PAGINATION = "setProgramsPagination";
export const SET_PROGRAM = "setProgram";
export const SET_PROGRAM_DESTINATIONS = "setProgramDestinations";
export const ADD_PROGRAM_DESTINATION = "addProgramDestination";
export const REMOVE_PROGRAM_DESTINATION = "removeProgramDestination";
export const SET_FILE_PROGRESS = "setFileProgress";
export const CLEAR_FILE_PROGRESS = "clearFileProgress";

const state = {
  programs: [],
  programsPagination: {
    total: 0,
    currentPage: 1,
    firstPage: 1,
    lastPage: 1,
    perPage: 0
  },
  program: {},
  programDestinations: [],
  programTypes: {
    1: "RTMP",
    2: "فایل/لینک"
  },
  programPlans: {
    1: "رایگان",
    3: "غیررایگان"
  },
  programsFilesProgress: {}
};

const getters = {
  programs(state) {
    return state.programs;
  },
  programsPagination(state) {
    return state.programsPagination;
  },
  program(state) {
    return state.program;
  },
  programDestinations(state) {
    return state.programDestinations;
  },
  programTypes(state) {
    return state.programTypes;
  },
  programPlans(state) {
    return state.programPlans;
  },
  programsFilesProgress(state) {
    return state.programsFilesProgress;
  }
};

const actions = {
  [FETCH_PROGRAMS](context, params = {}) {
    if (params.page === undefined) {
      params.page = context.state.programsPagination.currentPage;
    }

    return new Promise((resolve, reject) => {
      ApiService.query("programs", {
        params: params
      })
        .then(({ data }) => {
          context.commit(SET_PROGRAMS, data.data);
          context.commit(SET_PROGRAMS_PAGINATION, {
            total: data["total"],
            currentPage: data["current_page"],
            firstPage: data["first_page"],
            lastPage: data["last_page"],
            perPage: data["per_page"]
          });
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [FETCH_PROGRAM](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.get("programs", id)
        .then(({ data }) => {
          context.commit(SET_PROGRAM, data);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [STORE_PROGRAM](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post("programs", payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [UPDATE_PROGRAM](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.update("programs", payload.id, payload.formData)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [DESTROY_PROGRAM](context, id) {
    return new Promise(resolve => {
      ApiService.delete(`programs/${id}`).then(({ data }) => {
        resolve(data);
      });
    });
  },
  [UPLOAD_PROGRAM_FILE]({ commit }, payload) {
    const data = new FormData();
    data.append("file", payload.file);

    // axios config - progress bar
    const config = {
      onUploadProgress(progressEvent) {
        const progress = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        commit(SET_FILE_PROGRESS, {
          key: payload.program + "_" + payload.i,
          value: progress
        });
      }
    };

    return new Promise(resolve => {
      ApiService.post(`programs/${payload.program}/files`, data, config)
        .then(({ data }) => {
          commit(CLEAR_FILE_PROGRESS, payload.program + "_" + payload.i);
          resolve(data);
        })
        .catch(() => {
          commit(CLEAR_FILE_PROGRESS, payload.program + "_" + payload.i);
        });
    });
  },
  [GET_PROGRAM_FILE_URL](context, payload) {
    return new Promise(resolve => {
      ApiService.query(`programs/${payload.program}/files`, {
        params: { path: payload.path }
      }).then(({ data }) => {
        resolve(data);
      });
    });
  },

  [START_PROGRAM](context, programId) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`programs/${programId}/start`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [FETCH_PROGRAM_DESTINATIONS](context, programId) {
    return new Promise((resolve, reject) => {
      ApiService.get(`programs/${programId}/destinations`)
        .then(({ data }) => {
          context.commit(SET_PROGRAM_DESTINATIONS, data);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [STORE_PROGRAM_DESTINATION](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(`programs/${payload.programId}/destinations`, {
        destination: payload.destinationId
      })
        .then(({ data }) => {
          context.commit(ADD_PROGRAM_DESTINATION, data);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [DESTROY_PROGRAM_DESTINATION](context, destinationId) {
    let programDestinationId = "";
    context.state.programDestinations.forEach(function(sDestination) {
      if (sDestination["destination_id"] === destinationId) {
        programDestinationId = sDestination.id;
      }
    });
    return new Promise((resolve, reject) => {
      ApiService.delete(`programDestinations/${programDestinationId}`)
        .then(({ data }) => {
          context.commit(REMOVE_PROGRAM_DESTINATION, programDestinationId);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }
};

const mutations = {
  [SET_PROGRAMS](state, programs) {
    state.programs = programs;
  },
  [SET_PROGRAMS_PAGINATION](state, data) {
    state.programsPagination = data;
  },
  [SET_PROGRAM](state, program) {
    state.program = program;
  },
  [SET_PROGRAM_DESTINATIONS](state, programDestinations) {
    state.programDestinations = programDestinations;
  },
  [ADD_PROGRAM_DESTINATION](state, programDestination) {
    state.programDestinations.push(programDestination);
  },
  [REMOVE_PROGRAM_DESTINATION](state, programDestinationId) {
    state.programDestinations = state.programDestinations.filter(
      a => a.id !== programDestinationId
    );
  },
  [SET_FILE_PROGRESS](state, payload) {
    let old = {};
    Object.assign(old, state.programsFilesProgress);
    old[payload.key] = payload.value;
    state.programsFilesProgress = old;
  },
  [CLEAR_FILE_PROGRESS](state, key) {
    state.programsFilesProgress[key] = 0;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
